var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUUpLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 16.3125L1.25 8.4375L9.125 0.5625",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 26.8125H23.5625C25.9992 26.8125 28.3361 25.8445 30.059 24.1215C31.782 22.3986 32.75 20.0617 32.75 17.625V17.625C32.75 16.4185 32.5124 15.2238 32.0506 14.1091C31.5889 12.9944 30.9122 11.9816 30.0591 11.1285C29.2059 10.2753 28.1931 9.59857 27.0784 9.13685C25.9637 8.67514 24.769 8.4375 23.5625 8.4375H1.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUUpLeft);
export default __webpack_public_path__ + "static/media/arrowUUpLeft.68b18e9e02b00cff480129eca61e5136.svg";
export { ForwardRef as ReactComponent };